import { render, staticRenderFns } from "./App.vue?vue&type=template&id=158361d9&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=158361d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158361d9",
  null
  
)

/* custom blocks */
import block0 from "./App.vue?vue&type=custom&index=0&blockType=link&rel=stylesheet&href=https%3A%2F%2Ffonts.googleapis.com%2Fcss%3Ffamily%3DPoppins%253A200%252C400%252C400i%252C500%252C600%252C700%257CRoboto%253A300%252C300i%252C400%252C400i%252C500%252C500i%252C700%252C900%257CPacifico%257COpen%2520Sans%253A300%252C300i%252C400%252C400i%252C600%252C600i%252C700%252C700i%26%23038%3Bsubset%3Dlatin%2Clatin%252Clatin-ext%26%23038%3Bdisplay%3Dswap"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VContainer,VMain})
